export const dayFormat = 'DD/MMM/YYYY';